import React, { useState } from 'react';

const PasswordModal = ({ isOpen, onClose, onSuccess, projectName, onContactClick }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check password - both 2025 and 2026 passwords are valid
    const validPasswords = ['Kacey2025', 'Kacey2026'];

    if (validPasswords.includes(password)) {
      // Store in sessionStorage so they don't have to re-enter
      sessionStorage.setItem('caseStudyAuth', 'true');
      onSuccess();
      setPassword('');
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  // The resume shares this modal; everything else is a case study.
  const target = projectName === 'Resume' ? 'my resume' : `the ${projectName} case study`;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="relative bg-white rounded-[28px] shadow-xl max-w-md w-full p-8 sm:p-10">
        <button
          onClick={handleClose}
          aria-label="Close"
          className="absolute top-5 right-5 rounded-full p-2 text-muted hover:bg-canvas hover:text-ink transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <h2 className="pr-8 text-2xl font-bold tracking-tight text-ink">Access {projectName}</h2>
        <p className="mt-1 text-sm text-muted">Please enter the password to view {target}.</p>

        <form onSubmit={handleSubmit} className="mt-8">
          <label htmlFor="password" className="block text-xs font-bold uppercase tracking-widest text-tertiary mb-2">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 bg-canvas border border-gray-500 rounded-xl text-ink placeholder:text-gray-400 focus:outline-none focus:border-secondary focus:ring-2 focus:ring-secondary"
            placeholder="Enter password"
            autoFocus
          />
          {error && (
            <p className="mt-2 text-sm text-red-600">{error}</p>
          )}

          <button
            type="submit"
            className="mt-6 w-full rounded-full bg-ink px-8 py-3.5 text-[15px] font-medium text-white transition-colors duration-300 hover:bg-black focus:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2"
          >
            Submit
          </button>
        </form>

        <p className="mt-6 text-sm text-muted">
          Don't have the password? <button onClick={onContactClick} className="font-medium text-secondary hover:underline">Contact me</button>
        </p>
      </div>
    </div>
  );
};

export default PasswordModal;